/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  computed,
  type ReadonlySignal,
  type Signal,
  signal,
} from '@preact/signals-react'

import offlineDB from '@/indexeddb'
import type {
  TAuthState,
  TAuthCurrentUserState,
  TAuthModal,
  IMenuItem,
  IRole,
  TRole,
  TAuthUserPermission,
  EApplicationStatus,
} from '@/interfaces'

import { FormState } from '../form'
import { defaultEntityPermissions } from '../form/utils'

import { getRoutePathsFromMenu } from './utils'

const currentUser: Signal<TAuthCurrentUserState> = signal({})
const token: Signal<string | null> = signal(
  sessionStorage.getItem(offlineDB.userStoreIds.token) ?? null
)
const userRefresh: Signal<string | null> = signal(
  sessionStorage.getItem(offlineDB.userStoreIds.refreshData) ?? null
)
const resetPwdCode: Signal<string | null> = signal(null)
const isLoggedIn: ReadonlySignal<boolean> = computed(() => {
  return Boolean(token.value && currentUser.value.id)
})
const authModal: Signal<TAuthModal> = signal({
  data: null,
  open: false,
  type: null,
})
const currentRole: Signal<TRole | null> = signal(null)
const menu: Signal<IMenuItem[]> = signal([])
const roles: Signal<IRole[]> = signal([])
const routes: ReadonlySignal<string[]> = computed(() => {
  return getRoutePathsFromMenu(menu.value)
})

const userPermissions: Signal<Record<string, TAuthUserPermission>> = signal({})

const applicationPermission: ReadonlySignal<TAuthUserPermission> = computed(
  () => {
    const appPermissions =
      userPermissions.value.CSolicitud ?? defaultEntityPermissions

    return {
      ...appPermissions,
      edit:
        appPermissions.edit ||
        FormState.currentForm.value
          .filter((item) => item.name !== 'CObservacion')
          .some(
            (entity) =>
              entity.permission?.edit ??
              entity.permission?.create ??
              entity.permission?.delete
          ) ||
        defaultEntityPermissions.edit,
    }
  }
)

const statusChangeAllowed: ReadonlySignal<EApplicationStatus[]> = computed(
  () => currentUser.value?.statusPermissions ?? []
)

export const AuthState: TAuthState = {
  applicationPermission,
  authModal,
  currentRole,
  currentUser,
  isLoggedIn,
  menu,
  permissions: signal([]),
  resetPwdCode,
  roles,
  routes,
  statusChangeAllowed,
  token,
  userPermissions,
  userRefresh,
}
